export const T = {
  logo: "app-logo",
  themeToggle: "theme-toggle",
  toggleView: "toggle-view-mode",
  filterOpen: "filter-open-btn",
  filterSearchInput: "filter-search-input",
  filterCategoryBtn: (c) => `filter-cat-${c}`,
  filterStockBtn: (s) => `filter-stock-${s}`,
  filterApply: "filter-apply-btn",
  filterReset: "filter-reset-btn",
  requestOpen: "request-open-btn",
  requestForm: "request-form",
  requestName: "request-name-input",
  requestKontak: "request-kontak-input",
  requestBarang: "request-barang-input",
  requestCatatan: "request-catatan-input",
  requestSubmit: "request-submit-btn",
  productCard: (id) => `product-card-${id}`,
  productLike: (id) => `product-like-${id}`,
  productIntent: (id) => `product-intent-${id}`,
  productWa: (id) => `product-wa-${id}`,
  gridCard: (id) => `grid-card-${id}`,
  gridCardLike: (id) => `grid-like-${id}`,
  gridCardIntent: (id) => `grid-intent-${id}`,
  // admin
  adminLoginUser: "admin-login-username",
  adminLoginPass: "admin-login-password",
  adminLoginSubmit: "admin-login-submit",
  adminNavDashboard: "admin-nav-dashboard",
  adminNavProducts: "admin-nav-products",
  adminNavTrips: "admin-nav-trips",
  adminNavRequests: "admin-nav-requests",
  adminNavSettings: "admin-nav-settings",
  adminLogout: "admin-logout-btn",
  productNew: "admin-product-new",
  productSave: "admin-product-save",
  productStatusToggle: (id) => `admin-product-status-${id}`,
  productDelete: (id) => `admin-product-delete-${id}`,
  photoUpload: "admin-photo-upload",
  tripNew: "admin-trip-new",
  tripSave: "admin-trip-save",
  requestRow: (id) => `admin-request-row-${id}`,
  requestStatusChange: (id, s) => `admin-request-${id}-${s}`,
  settingsSave: "admin-settings-save",
  settingsAddWa: "admin-settings-add-wa",
};

export default T;
